// extracted by mini-css-extract-plugin
export default {"fineprint":"SMLDeletePageSheet_fineprint__LOMcs","footerNote":"SMLDeletePageSheet_footerNote__c3dUw","footerLink":"SMLDeletePageSheet_footerLink__Tfo2L"};